<template>
    <PageCard sm>
        <div class="mb-2 d-flex items-center justify-content-between" style="gap: 10px">
            <SectionTitle class="">Monthly Attendance</SectionTitle>
        </div>
        <Spinner v-if="!showChart" />
        <apexchart v-if="showChart" type="bar" height="300" :options="chartOptions" :series="series"></apexchart>
    </PageCard>
</template>

<script>
import { mapActions, mapState } from "vuex"
import PageCard from "../layout/PageCard.vue"
import SectionTitle from "../UI/SectionTitle.vue"
import Spinner from "../UI/Spinner.vue"

export default {
    components: { PageCard, SectionTitle, Spinner },
    data() {
        return {
            showChart: false,
            series: [
                {
                    name: "Monthly Attendance",
                    data: [],
                },
            ],
            chartOptions: {
                chart: {
                    type: "bar",
                    height: 300,
                    zoom: {
                        enabled: false,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: "straight",
                },

                // title: {
                //     text: "Attendance Comparison Chart",
                //     align: "left",
                // },
                // subtitle: {
                //     text: "Price Movements",
                //     align: "left",
                // },
                xaxis: {
                    // type: "datetime",
                    categories: [],
                    labels: {
                        style: {
                            fontSize: "10px", // Adjust the font size as needed
                        },
                    },
                },
                yaxis: {
                    min: 0,
                    max: 100,
                    tickAmount: 5,
                    labels: {
                        formatter: function (value) {
                            return value + "%"
                        },
                    },
                },
                legend: {
                    horizontalAlign: "left",
                },
            },
        }
    },
    computed: {
        ...mapState("misc", ["departmentWiseAttendance"]),
    },
    mounted() {
        this.loadChart()
    },
    methods: {
        ...mapActions("misc", []),
        loadChart() {
            const data = this.departmentWiseAttendance

            if (data) {
                this.series[0].data = data.map((item) => item.percentage)
                this.chartOptions.xaxis.categories = data.map((item) => item.title)
                this.showChart = true
            }
        },
    },
    watch: {
        departmentWiseAttendance(e) {
            if (e) {
                this.loadChart()
            }
        },
    },
}
</script>

<style></style>
